<div class="{{ large ? 'body-2' : 'body-3' }} {{ messageClass }}" [ngClass]="color?.length ? color : (warning ? 'text-warning' : 'text-muted')">
  <mat-icon class="svg-icon" *ngIf="!noIcon" [svgIcon]="icon ? icon : (warning ? 'warning' : 'info')"></mat-icon>
  {{ message | translate }}
  <mat-icon class="svg-icon text-grey" *ngIf="tooltip" [svgIcon]="'info'" [matTooltip]="tooltip | translate"></mat-icon>
</div>
